module.exports = __webpack_public_path__ + "static/media/JH_web_10.52f1ab50.jpg";